/**
 * Cache odpowiedzi /api/auth/me w localStorage.
 *
 * HTML stron jest cache'owany na Cloudflare i renderowany bez sesji, wiec front
 * nie dostaje od serwera informacji, kto jest zalogowany. Sygnalem jest
 * ciasteczko sesji: nie jest HttpOnly ani szyfrowane, a Laravel zmienia jego
 * wartosc przy kazdym zalogowaniu (regenerate / migrate) i wylogowaniu
 * (invalidate). Wpis z innej sesji jest wiec niewiarygodny, a wpis z tej samej
 * sesji jest aktualny do uplywu TTL.
 */
export const AUTH_CACHE_KEY = 'auth_user';
const AUTH_META_KEY = 'auth_user_meta';
const SESSION_COOKIE = 'laravel_savicki_session';

// Zalogowany: punkty i poziom lojalnosciowy zmieniaja sie po stronie backendu.
const USER_TTL = 10 * 60 * 1000;
// Gosc: zalogowanie zawsze zmienia ID sesji, TTL jest tylko bezpiecznikiem.
const GUEST_TTL = 24 * 60 * 60 * 1000;

export const getSessionId = () => {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${SESSION_COOKIE}=([^;]*)`));
    return match ? match[1] : null;
};

const readMeta = () => {
    try {
        return JSON.parse(localStorage.getItem(AUTH_META_KEY)) || null;
    } catch {
        return null;
    }
};

/**
 * @returns {{ user: object|null, sameSession: boolean, isFresh: boolean }|null}
 *          null, gdy w cache nic nie ma.
 */
export const readAuthCache = () => {
    try {
        const raw = localStorage.getItem(AUTH_CACHE_KEY);
        if (raw === null) return null;

        const user = JSON.parse(raw);
        const meta = readMeta();
        const sameSession = !!meta && meta.sid === getSessionId();
        const ttl = user ? USER_TTL : GUEST_TTL;

        return {
            user,
            sameSession,
            isFresh: sameSession && Date.now() - (meta.at || 0) < ttl,
        };
    } catch {
        return null;
    }
};

/**
 * Wolac PO odpowiedzi z serwera - Set-Cookie z nowym ID sesji jest juz wtedy
 * zapisany w przegladarce.
 */
export const writeAuthCache = (user, { keepTimestamp = false } = {}) => {
    try {
        const at = keepTimestamp ? readMeta()?.at || 0 : Date.now();
        localStorage.setItem(AUTH_META_KEY, JSON.stringify({ sid: getSessionId(), at }));
        localStorage.setItem(AUTH_CACHE_KEY, JSON.stringify(user));
    } catch {
        // brak dostepu do storage - kolejna strona po prostu zapyta /me
    }
};

export const clearAuthCache = () => {
    try {
        localStorage.removeItem(AUTH_CACHE_KEY);
        localStorage.removeItem(AUTH_META_KEY);
    } catch {
        // ignore
    }
};

/** Dane usera zostaja do wyswietlenia, ale nastepne me() pobierze swieze. */
export const expireAuthCache = () => {
    const meta = readMeta();
    if (!meta) return;
    try {
        localStorage.setItem(AUTH_META_KEY, JSON.stringify({ ...meta, at: 0 }));
    } catch {
        // ignore
    }
};
